import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

//React Globals
global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

//App Components
import { DemoComponent } from './test/demo';
import { GalleryComponent } from './components/gallery/prototype/gallery';
import { ChairsGalleryComponent } from './components/gallery/prototype/gallery';
import { CollectionGalleryComponent } from './components/gallery/prototype/gallery'; 
import { ProductGalleryComponent } from './components/gallery/gallery';
import { FabricGalleryComponent } from './components/gallery/fabric-gallery';
import { FinishGalleryComponent } from './components/gallery/finish-gallery';
import { SearchGalleryComponent } from './components/gallery/search-gallery';
import StoreLocatorComponent from './components/store-locator/store-locator.jsx';
import ContactRepComponent from './components/contact-rep/contact-rep.jsx';
import ConfigureComponent from './components/configure/configure.jsx';
import QuoteHistoryGrid from './components/quote/quote-history-grid.jsx';
import RegistrationHistoryGrid from './components/registration/registration-history-grid.jsx';
import FavoritesGalleryComponent from './components/favorites/favorites-gallery.jsx';
import GradedInSearchComponent from './components/graded-in/graded-in-search.jsx';
import ResourcesPageComponent from './components/resources/resources-page.jsx';
import AdminUsersGrid from './components/admin/admin-users-grid.jsx';
import FabricSampleOrdersGrid from './components/admin/fabric-sample-orders-grid.jsx';
import FabricCartComponent from './components/fabric-cart/cart.jsx';
import FabricCartCheckoutComponent from './components/fabric-cart/checkout.jsx';
import DataverseSearchGrid from './components/admin/dataverse-search-grid.jsx';
import ManageSkuStatusGrid from './components/admin/manage-sku-status-grid.jsx';
import SalesRepUsersGrid from './components/admin/salesrep-users-grid.jsx';
import SalesRepsAdminGrid from './components/admin/salesreps-admin-grid.jsx';
import SalesRepDetailComponent from './components/admin/salesrep-detail.jsx';
import UnassignedDealersGrid from './components/admin/unassigned-dealers-grid.jsx';
import { TitlesGridComponent, TradeGridComponent,WoodFinishesComponent } from './cms/home/index.jsx';
import { FairfieldButtonLinkComponent, FairfieldPdfLinkComponent, FairfieldGalleryButtonComponent } from './cms/components/button-link.jsx';
import { MultiSlideCarouselComponent1,MultiSlideAltCarouselComponent } from './cms/components/multi-slide-carousel.jsx';
import { FadeCarouselComponent } from './cms/components/fade-carousel.jsx';
import { FourImageGridComponent, TwoImageGridComponent } from './cms/components/image-grid.jsx';
import { NotificationBarManage } from './components/admin/notification-bar.jsx';

//Cms Components
import {
    HeroTitle,
    H2Title,
    H3Title,
    H4Title,
    H5Title,
    H1Title,
    SpanText,
    BlockQuotation,
    ListEditor,
    ImageLink,
    HeaderTitleComponent,
    HeroTitleComponent,
    H3TitleComponent,
    H4TitleComponent,
    H5TitleComponent,
    SpanTextComponent,
    HTitleComponent,
    HeroComponent,
    HeroPictureComponent,
    HeroPictureTitleComponent,
    HeroImageComponent,
    HeroPictureLinkComponent,
    HeroImageLinkComponent,
    ImageComponent,
    HtmlEditorComponent,
    HeaderListComponent,
    HeroTitleListComponent,
    EditorListComponent,
    TinyEditorComponent,
    MinimalEditorComponent,
    ContentEditableComponent,
    TitleContentEditableComponent,
    TitleTinyEditorComponent,
    BlockQuoteComponent,
    VideoComponent,
    H2TitleComponent

} from '../library/cms/content-components';

import ButtonLinkComponent  from '../library/cms/button-link';
import CarouselComponent from '../library/cms/carousel';

import {
    PageEmbeddedApp, PageApp

} from './page/apps';

import PagesSummaryApp from './page/summary';


global.Components={
    DemoComponent,
    GalleryComponent,
    ChairsGalleryComponent,
    CollectionGalleryComponent,
    ProductGalleryComponent,
    FabricGalleryComponent,
    FinishGalleryComponent,
    SearchGalleryComponent,
    StoreLocatorComponent,
    ContactRepComponent,
    ConfigureComponent,
    QuoteHistoryGrid,
    FavoritesGalleryComponent,
    GradedInSearchComponent,
    ResourcesPageComponent,
    TitlesGridComponent,
    TradeGridComponent,
    WoodFinishesComponent,
    FairfieldButtonLinkComponent,
    FairfieldPdfLinkComponent,
    FairfieldGalleryButtonComponent,
    MultiSlideCarouselComponent1,
    MultiSlideAltCarouselComponent,
    FadeCarouselComponent,
    FourImageGridComponent,
    TwoImageGridComponent,
    RegistrationHistoryGrid,
    AdminUsersGrid,
    FabricSampleOrdersGrid,
    FabricCartComponent,
    FabricCartCheckoutComponent,
    SalesRepUsersGrid,
    SalesRepsAdminGrid,
    SalesRepDetailComponent,
    UnassignedDealersGrid,
    DataverseSearchGrid,
    ManageSkuStatusGrid,
    NotificationBarManage
};

global.Cms = {
    HeroTitle,
    H2Title,
    H3Title,
    H4Title,
    H5Title,
    H1Title,
    SpanText,
    BlockQuotation,
    SpanText,
    ListEditor,
    ImageLink,
    HeaderTitleComponent,
    HeroTitleComponent,
    H2TitleComponent,
    H3TitleComponent,
    H4TitleComponent,
    H5TitleComponent,
    SpanTextComponent,
    HTitleComponent,
    HTitleComponent,
    HeroComponent,
    HeroPictureComponent,
    HeroPictureTitleComponent,
    HeroImageComponent,
    HeroPictureLinkComponent,
    HeroImageLinkComponent,
    ImageComponent,
    HtmlEditorComponent,
    HeaderListComponent,
    HeroTitleListComponent,
    EditorListComponent,
    TinyEditorComponent,
    MinimalEditorComponent,
    ContentEditableComponent,
    TitleContentEditableComponent,
    TitleTinyEditorComponent,
    BlockQuoteComponent,
    HTitleComponent,
    VideoComponent,
    ButtonLinkComponent,
    CarouselComponent,
    PageEmbeddedApp,
    PageApp,
    PagesSummaryApp
};

global.serviceRootEndpoint = '/api';
global.mediaFileBaseUrl ='https://cdn.fairfieldchair.com/azure/medialibrary/';
//global.mediaFileBaseUrl ='https://fairfield-img-cdn-bkdkhrafgjayhwh4.z01.azurefd.net/azure/medialibrary/';
//global.mediaFileBaseUrl ='https://fairfieldimageserver-gpedezbqfrdpewbv.eastus-01.azurewebsites.net/azure/medialibrary/';
//global.mediaFileBaseUrl = '';